import { classNames } from 'tradera/utils/class-names';
import React from 'react';
import type { Attribute } from 'tradera/state/services/types/touchweb-search-api.types';
import { Button } from 'tradera/components/atoms/button/button';
import style from './attribute-buttons-list.module.scss';

type AttributeButtonsListProps = {
    visibleAttributes?: (Attribute | null)[];
    onClick: (attr: Attribute | null) => void;
    className?: string;
};

export const AttributeButtonsList = ({
    visibleAttributes,
    onClick,
    className
}: AttributeButtonsListProps) => {
    return (
        <p className={classNames('d-flex flex-row flex-wrap mb-0', className)}>
            {visibleAttributes?.map((attribute) => (
                <Button
                    key={attribute?.name}
                    theme="link"
                    linkReverted
                    className={classNames('text-gray-600', style.attribute)}
                    onClick={() => onClick(attribute)}>
                    {attribute?.values.join('/') ?? ''}
                </Button>
            ))}
        </p>
    );
};
